import $ from 'jquery';

$(function () {
  const $password = $('#employee_password');
  const $passwordConfirmation = $('#employee_password_confirmation');
  const $submitButton = $('#submit-password-change');

  if ($password.length === 0 || $passwordConfirmation.length === 0) return;

  // Disable the button initially when JavaScript loads
  $submitButton.prop('disabled', true);

  // Track validation state for each requirement
  const validationState = {
    match: false,
    length: false,
    repeating: false,
    sequence: false
  };

  // Password toggle functionality
  $('.password-toggle').on('click', function () {
    const $toggle = $(this);
    const $input = $($toggle.data('target'));
    const $icon = $toggle.find('i');

    if ($input.attr('type') === 'password') {
      $input.attr('type', 'text');
      $icon.removeClass('fa-eye').addClass('fa-eye-slash');
    } else {
      $input.attr('type', 'password');
      $icon.removeClass('fa-eye-slash').addClass('fa-eye');
    }
  });

  function validatePassword() {
    const password = $password.val();
    const passwordConfirmation = $passwordConfirmation.val();

    // Passwords must match (only validate if both fields have values)
    if (password.length > 0 && passwordConfirmation.length > 0) {
      validationState.match = password === passwordConfirmation;
      validateRequirement('#requirement-match', validationState.match);
    } else {
      validationState.match = false;
      resetRequirement('#requirement-match');
    }

    // Minimum 15 characters
    validationState.length = password.length >= 15;
    validateRequirement('#requirement-length', validationState.length);

    // No repeating characters (aaa, 111)
    validationState.repeating = !/(.)\1{2,}/.test(password);
    validateRequirement('#requirement-repeating', validationState.repeating);

    // No sequences of numbers (012, 123, 234, etc.)
    validationState.sequence = !/(012|123|234|345|456|567|678|789|890)/.test(password);
    validateRequirement('#requirement-sequence', validationState.sequence);

    // Cannot reuse any of your last 10 passwords (server-side only, leave neutral)
    // This will be validated on submit, not real-time

    // Enable/disable submit button based on all validations
    updateSubmitButton();
  }

  function validateRequirement(selector, isValid) {
    const $element = $(selector);
    const $icon = $element.find('.requirement-icon');
    const $text = $element.find('.requirement-text');
    
    if (isValid) {
      $icon.removeClass('fa-circle fas fa-times-circle far').addClass('far fa-check-circle').css({'color': 'green', 'font-size': '12px'});
      $text.css('color', 'black');
    } else {
      $icon.removeClass('fa-circle fas far fa-check-circle').addClass('far fa-times-circle').css({'color': 'red', 'font-size': '12px'});
      $text.css('color', 'black');
    }
  }

  function resetRequirement(selector) {
    const $element = $(selector);
    const $icon = $element.find('.requirement-icon');
    const $text = $element.find('.requirement-text');
    
    $icon.removeClass('far fa-check-circle fa-times-circle').addClass('fas fa-circle').css({'color': '#999', 'font-size': '12px'});
    $text.css('color', '');
  }

  function updateSubmitButton() {
    // Check if all requirements are met (except history which is server-side only)
    const allValid = Object.values(validationState).every(val => val === true);
    
    if (allValid) {
      $submitButton.prop('disabled', false);
    } else {
      $submitButton.prop('disabled', true);
    }
  }

  // Bind validation to input events
  $password.on('input keyup', validatePassword);
  $passwordConfirmation.on('input keyup', validatePassword);
});
